const API = "/api/auth";

async function request(path, options = {}) {
  let res;
  try {
    res = await fetch(`${API}/${path}`, {
      credentials: "include",
      headers: { "Content-Type": "application/json", ...(options.headers || {}) },
      ...options,
    });
  } catch {
    throw new Error("Network error — check your connection and try again.");
  }

  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }

  if (!res.ok) {
    const isSignup = path === "signup";
    const fallback = isSignup
      ? `Sign up failed (error ${res.status}). Please try again.`
      : `Login failed (error ${res.status}). Please try again.`;
    throw new Error(
      data.error
      || (res.status === 503 ? "Accounts are not ready yet. Please try again later."
        : res.status === 403 ? "Please verify your account first — check your email or SMS."
          : res.status === 401 ? "Invalid email/mobile or password."
            : fallback)
    );
  }
  return data;
}

export function fetchMe() {
  return request("me");
}

export function signup({ name, password, method, email, phone }) {
  return request("signup", {
    method: "POST",
    body: JSON.stringify({ name, password, method, email, phone }),
  });
}

export function login({ method, email, phone, password }) {
  return request("login", {
    method: "POST",
    body: JSON.stringify({ method, email, phone, password }),
  });
}

export function logout() {
  return request("logout", { method: "POST" });
}

export function forgotPassword({ method, email, phone }) {
  return request("forgot", {
    method: "POST",
    body: JSON.stringify({ method, email, phone }),
  });
}

export function resetPassword({ token, phone, code, password }) {
  return request("reset", { method: "POST", body: JSON.stringify({ token, phone, code, password }) });
}

export function verifyAccount({ email, phone, code, token }) {
  return request("verify", { method: "POST", body: JSON.stringify({ email, phone, code, token }) });
}

export function resendVerify({ email, phone }) {
  return request("resend-verify", { method: "POST", body: JSON.stringify({ email, phone }) });
}

// Legacy aliases
export const verifyEmail = verifyAccount;
